<template>
  <div class="flex items-center">
    <label
      v-if="label"
      class="mr-3"
    >{{ label }}</label>
    <vs-switch
      v-model="inputValue"
      class="mr-3"
    />
  </div>
</template>

<script>

export default {
  name: 'SwitchField',
  props: {
    modelValue: {
      type: [Boolean, Number],
      default: null
    },
    label: {
      type: String,
      default: null
    }
  },
  emits: ['update:modelValue'],
  computed: {
    inputValue: {
      get () {
        return !!this.modelValue
      },
      set (newValue) {
        if (typeof this.modelValue === 'number') {
          return this.$emit('update:modelValue', newValue ? 1 : 0)
        }
        return this.$emit('update:modelValue', newValue)
      }
    }
  }
}
</script>

<style scoped>

</style>
